import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from '../config/config.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  isAuthenticated : boolean = false;
  clientAppName: string;
  constructor(
    private router: Router,
    private navigator: Navigator,
    private configService: ConfigService
  ){ 

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    /*return this.userSessionService.isAuthenticated().then(isAuthenticated => {
      this.isAuthenticated = isAuthenticated;
      console.log('---user is authenticated---', this.isAuthenticated);
      if (!this.isAuthenticated){
        this.navigator.toTab('/');
        return false;
      } 
      return true;
    });*/


    //improve the code later
   /* if (window.location.origin == "https://sdtest-play.palainteractive.com") {
      this.router.navigate(['landing']);
      return false;
    } else if (
      window.location.origin == "https://sdnjtest-play.palainteractive.com"
    ) {
      console.log(window.location.origin);
      return true;
    } else if (
      window.location.origin == "https://sdpatest-play.palainteractive.com"
    ) {
      console.log(window.location.origin);
      return true;
    } else {
      console.log(window.location.origin);
      return true;
    }*/
   this.clientAppName = this.configService.getClientApp();
   console.log(this.clientAppName)
   if(this.clientAppName.includes('PA')){
    return true;
   } else if(this.clientAppName.includes('NJ')){
    return true;
   } else {
    return false;
   }
 }
}
